// extracted by mini-css-extract-plugin
export var individual = "about-module--individual--Kcy14";
export var image = "about-module--image--tm64C";